import PropTypes from "prop-types";
import { Typography as MuiTypography } from "@mui/material";
import { useTranslation } from "react-i18next";

const headerStyles = {
  lineHeight: 1.2,
  textOverflow: "clip",
  whiteSpace: "pre-line",
  fontSize: "15px",
  fontWeight: 600,
  marginTop: "12px",
};

/**
 * Utility component to make building a consistent table header
 * cell in DataGrid's GridColDef.renderHeader or renderCell properties.
 * Or anywhere it is not possible to utilize react-i18next's useTranslation hook.
 *
 * @param {object} props
 * @param {string} props.tlEntry A translation file entry (e.g. "admin.open.label")
 * @param {object} [props.tlParams] Optional parameters object the tlEntry requires
 * @param {bool} [props.isMultiLine] Does the header text wrap to more than one line?
 * @param {object} [props.extraStyles] Optional extra styles to add or override
 */
const TranslatableTypography = ({
  tlEntry,
  tlParams = null,
  isMultiLine = false,
  extraStyles = {},
}) => {
  const { t } = useTranslation();
  const headerString = t(tlEntry, tlParams);
  const styles = {
    ...headerStyles,
    ...extraStyles,
  };

  return (
    <MuiTypography style={styles}>
      {headerString}
      {!isMultiLine && (
        <>
          <br />
          &nbsp;
        </>
      )}
    </MuiTypography>
  );
};

TranslatableTypography.props = {
  tlEntry: PropTypes.string.isRequired,
  tlParams: PropTypes.object,
  isMultiLine: PropTypes.bool,
  extraStyles: PropTypes.object,
};

export default TranslatableTypography;
